import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import visionflowPlugin from '@internal/plugin-visionflow';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { appOverrides } from './modules/appOverrides';
import { legalPagesModule } from './modules/pages';
import { scaffolderFieldsModule } from './scaffolder';
import { translationsModule } from './modules/translations';

export default createApp({
  features: [
    catalogPlugin,
    // Business pages of the portal (document anonymization, ...).
    visionflowPlugin,
    navModule,
    homeModule,
    appOverrides,
    legalPagesModule,
    scaffolderFieldsModule,
    // German translations for all installed plugins (see translations/).
    translationsModule,
  ],
});
